import * as React from "react";
import styled from "@emotion/styled";

const AdvantageWrapper = styled.div`
    position: relative;
`

export default function SectionAdvantages({ pageClass, classGrid, title, advantages }) {
    return (
        <AdvantageWrapper>
            <div
                className={`${pageClass === 'walletPage' || pageClass === 'tokenPage' ? 'padding-bottom-top background-color-advantages-wallet' : 
                'padding-global background-color-advantages-home'}`}>
                    <div
                        data-aos='fade-up'
                        data-aos-duration='1000'
                        className="container-large">
                        <div className="main-container-block">
                            {classGrid === "card-grid-wallet" && (
                                <h3 className="heading-style-h3 text-desktop-mobile margin-vertical margin-bottom-auto">
                                    {title}
                                </h3>
                            )}
                            <div className={classGrid}>
                                {classGrid !== "card-grid-wallet" && (
                                    <h3 className="heading-style-h3 text-desktop-mobile margin-bottom-xsmall margin-vertical">
                                        {title}
                                    </h3>
                                )}
                                <div className={`w-layout-grid ${classGrid === 'card-grid-token' || classGrid === 'card-grid' ? 'grid-4' : 'grid-3' }`}>
                                    {advantages.map((card, index) => {
                                        return (
                                            <div id={card.id} key={index} className="box-container">
                                                <div className={`card-icon`}>
                                                    <div className="icon-wrapper-advantages">
                                                        <img
                                                            src={card.src || ''}
                                                            loading="lazy"
                                                            alt=""
                                                            width={card.width}
                                                            className="card-svg"
                                                        ></img>
                                                    </div>
                                                    <h1 className="card-title">{card.title}</h1>
                                                    <p
                                                        className={`${card.title ? 'card-text' : 'card-text-middle'} card-text paragraph18 font-paragraph margin-top`}>
                                                        {card.text}
                                                    </p>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </AdvantageWrapper>
    );
}
